import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AdminImportRequestItemShow } from './useFetchAdminImportRequestItemShow';

type CloseAdminImportRequestItemParams = {
  importRequestId: number;
  itemId: number;
};

export default function useCloseAdminImportRequestItem() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (params: CloseAdminImportRequestItemParams) => {
      const response = await fetch(
        `/admin/api/import_requests/${params.importRequestId}/items/${params.itemId}/close`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-CSRF-Token': token || '',
          },
        }
      );
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error((body as { error?: string }).error ?? '求人クローズの記録に失敗しました');
      }
      return (await response.json()) as AdminImportRequestItemShow;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['admin', 'import_requests', variables.importRequestId, 'items'],
      });
      queryClient.invalidateQueries({
        queryKey: [
          'admin',
          'import_requests',
          variables.importRequestId,
          'items',
          variables.itemId,
        ],
      });
    },
  });
}
